import { z } from 'zod'

export const TaskTypeSchema = z.enum([
  'AcknowledgeEvaluation',
  'Birthday',
  'CalendarEvent',
  'ConfirmAppointment',
  'ConfirmEventOutcome',
  'ConfirmManagerInterview',
  'Custom',
  'ExternalLink',
  'ConfirmShadowDay',
  'ConversionFromPitchToLead',
  'FixIntegrationMapping',
  'GradeEvaluation',
  'GameInvitations',
  'GameRaffles',
  'GamePickPrizes',
  'MilestoneAllTimeApprove',
  'MilestoneAllTimeInstall',
  'MilestoneAllTimeLead',
  'MilestoneAllTimePitch',
  'MilestoneFirstPitch',
  'MilestoneLastMonthApprove',
  'MilestoneLastMonthInstall',
  'MilestoneLastMonthLead',
  'MilestoneLastMonthPitch',
  'MilestoneThisQuarterApprove',
  'MilestoneThisQuarterInstall',
  'MilestoneThisQuarterLead',
  'MilestoneThisQuarterPitch',
  'SalesActivity',
  'SalesTraining',
  'ScheduleInterview',
  'SetCloserSettings',
  'SendMessage',
  'SubmitQuarterlyPlan',
  'SubmitWeeklyPlan',
  'ReauthorizeGoogle',
  'RecordConversation',
  'RecordEvaluation',
  'ResubmitRejectedPlan',
  'ReviewSubmittedPlan',
  'TakeQuiz',
  'TimeSinceLastApprove',
  'TimeSinceLastLead',
  'TimeSinceLastPitch',
  'UpdateCloserAvailability',
  'UploadProfilePicture',
  'WatchVideo',
  'WorkAnniversary',
  'WorkflowTasks',
])
export type TaskType = z.infer<typeof TaskTypeSchema>

export const TaskActionSchema = z.object({
  label: z.string(),
  link: z.string().optional(),
  value: z.union([z.string(), z.number(), z.boolean()]).optional(),
})
export type TaskAction = z.infer<typeof TaskActionSchema>
